function ImHandler(accountModel, classModel, tim) {
  this.accountModel = accountModel;
  this.classModel = classModel;
  this.sendMsgFailMap = {};
  this.tim = tim;
}

ImHandler.prototype.sendGroupSignal = function (content) {
  let message = this.tim.createCustomMessage({
    // to: this.accountModel.classId + '0000',
    to: this.accountModel.classId + '',
    conversationType: window.TIM.TYPES.CONV_GROUP,
    payload: {
      data: JSON.stringify(content),
      description: '',
      extension: 'hySignalExt'
    }
  })
  this.tim.sendMessage(message).then(() => {
  }, () => {
    // 失败重试一次
    setTimeout(function () {
      this.sendGroupSignal(content);
    }, 500);
  });

}
ImHandler.prototype.sendP2pSignal = function (to, content) {
  let message = this.tim.createCustomMessage({
    to: to,
    conversationType: TIM.TYPES.CONV_C2C,
    payload: {
      data: JSON.stringify(content),
      description: '',
      extension: 'hySignalExt'
    }
  })
  this.tim.sendMessage(message).then(() => {
  }, () => {
    // 失败重试一次
    setTimeout(function () {
      this.sendP2pSignal(content);
    }, 500);
  });
}

/**
 * 传输白板数据
 * @param {*} content 
 */
ImHandler.prototype.sendBoardGroupCustomMessage = function (content) {
  let message = this.tim.createCustomMessage({
    to: this.accountModel.classId + '',
    // to: this.accountModel.classId + '0000',
    conversationType: window.TIM.TYPES.CONV_GROUP,
    payload: {
      data: content,
      description: '',
      extension: 'TXWhiteBoardExt'
    }
  })
  this.tim.sendMessage(message).then(() => {
    // 同步成功
  }, () => {
    // 同步失败
    this.retrySendBoardGroupCustomMessage(message);
  });
}

/**
 * 重试逻辑
 * @param {*} msg 
 */
ImHandler.prototype.retrySendBoardGroupCustomMessage = function (msg) {
  // 重试3次
  if ((this.sendMsgFailMap[msg.id+ ''] || 0) > 1) {
    return;
  }
  this.sendMsgFailMap[msg.id+ ''] = (this.sendMsgFailMap[msg.id+ ''] || 0) + 1;

  this.tim.sendMessage(msg).then(() => {
    // 同步成功
  }, () => {
    // 同步失败
    this.retrySendBoardGroupCustomMessage(msg);
  });
}

/**
 * 发送普通文本消息
 * @param {*} selType 接收方类型（个人/群组）
 * @param {*} msgText 消息内容
 * @param {*} toUser 接收方ID
 */
ImHandler.prototype.sendTextMessage = function (selType, msgText, toUser, succ, fail) {
  // 发送文本消息，Web 端与小程序端相同
// 1. 创建消息实例，接口返回的实例可以上屏
  let message = this.tim.createTextMessage({
    to: toUser,
    conversationType: selType,
    // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
    // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
    // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
    payload: {
      text: msgText
    }
  });
// 2. 发送消息
  let promise = this.tim.sendMessage(message);
  promise.then(function(imResponse) {
    // 发送成功
    console.log(imResponse);
    succ && succ();
  }).catch(function(imError) {
    // 发送失败
    console.warn('sendMessage error:', imError);
    fail && fail(imError);
  });
}

/**
 * 发送自定义消息
 * @param {*} selType 接收方类型（个人/群组）
 * @param {*} msgObj 消息内容
 * @param {*} toUser 接收方ID
 */
ImHandler.prototype.sendCustomMsg = function (selType, msgText, toUser, succ, fail) {
  var tim = this.tim;
  let message = tim.createCustomMessage({
    to: toUser,
    conversationType: selType,
    // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
    // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
    // priority: TIM.TYPES.MSG_PRIORITY_HIGH,
    payload: {
      data: '', 
      description: msgText, // 获取骰子点数
      extension: ''
    }
  });
// 3. 发送消息
  let promise = tim.sendMessage(message);
  promise.then(function(imResponse) {
    // 发送成功
    console.log(imResponse);
    succ && succ();
  }).catch(function(imError) {
    // 发送失败
    console.warn('sendMessage error:', imError);
    fail && fail(err);
  });
}

/**
 * 获取unixTimestamp时间戳
 */
ImHandler.prototype.getUnixTimestamp = function () {
  return Math.round(new Date().getTime() / 1000);
}

export default ImHandler;